import React, { Component } from "react";
import { withRouteSpeedColor } from "../../../shared/containers/containerRouteSpeedColor";
import { withMapPositions } from "../../../shared/containers/containerMapPositions";
import AntPath from "../../AntPath/AntPath";
import { Polyline, Popup } from "react-leaflet";
import { withMapControl } from "../../../shared/containers/containerMapControl";
import PolylineArrorw from "../../PolylineDecorator/PolylineArrow";
import { v4 as uuidv4 } from "uuid";

class IntelligenceMapSpeedColorRoute extends Component {
  constructor(props) {
    super(props);

    this.state = {
      colorRoutes: [],
      viewAnimation: false,
      viewRoute: false,
    };
  }

  componentDidMount() {
    const { mapPositionsData } = this.props;
    const { viewAnimation, viewRoute } = this.props.mapOverlayers;

    if (mapPositionsData.length >= 3) {
      const colorRoutes = this.getSpeedColorArray();

      this.setState({ colorRoutes, viewAnimation, viewRoute });
    }
  }

  componentDidUpdate(prevProps) {
    const { mapPositionsData, routeSpeedColorKey } = this.props;
    const { viewAnimation, viewRoute } = this.state;

    if (mapPositionsData.length >= 3 && routeSpeedColorKey !== prevProps.routeSpeedColorKey) {
      const colorRoutes = this.getSpeedColorArray();

      this.setState({ colorRoutes });
    }

    if (this.props.mapOverlayers.viewRoute !== viewRoute) {
      this.setState({ viewRoute: this.props.mapOverlayers.viewRoute });
    }

    if (this.props.mapOverlayers.viewAnimation !== viewAnimation) {
      this.setState({ viewAnimation: this.props.mapOverlayers.viewAnimation });
    }
  }

  getColor(item) {
    const { routeSpeedColor } = this.props;

    const defaultColor = "#000000";
    let color = defaultColor;

    const itemColor = routeSpeedColor.items.filter((x) => {
      return item.speed >= x.min && item.speed <= x.max;
    })[0];

    if (itemColor !== undefined) {
      color = itemColor.color;
    }

    return color;
  }

  getSpeedColorArray() {
    const { mapPositionsData } = this.props;

    if (mapPositionsData.length < 3) return [];

    const arrayC = [];

    arrayC.push({
      color: this.getColor(mapPositionsData[0]),
      items: [mapPositionsData[0]],
    });

    for (let i = 1; i < mapPositionsData.length - 1; i++) {
      const color = this.getColor(mapPositionsData[i]);

      arrayC[arrayC.length - 1].items.push(mapPositionsData[i]);

      if (arrayC[arrayC.length - 1].color !== color) {
        arrayC.push({
          color: color,
          items: [mapPositionsData[i]],
        });
      }
    }

    return arrayC;
  }

  render() {
    const { mapPositionsData, handlePoupupArrow, handlePoupup } = this.props;
    const { colorRoutes, viewAnimation, viewRoute } = this.state;

    if (mapPositionsData.length < 3) return null;

    return (
      <div>
        {colorRoutes.map((x, index) => {
          const positions = x.items.map((position) => {
            return [position.location.lat, position.location.long];
          });

          if (viewAnimation) {
            return (
              <div key={index}>
                {viewRoute ? (
                  <AntPath
                    key={index + x.color}
                    positions={positions}
                    options={{
                      delay: 1000,
                      dashArray: [30, 200],
                      weight: 3,
                      color: x.color,
                      opacity: 1,
                      pulseColor: "#FFFFFF",
                      hardwareAccelerated: true,
                    }}
                    eventHandlers={{
                      click: handlePoupup,
                    }}
                  >
                    <Popup className="mapPopup" />
                  </AntPath>
                ) : null}
              </div>
            );
          }

          return (
            <div key={index}>
              {viewRoute ? (
                <Polyline
                  pathOptions={{ color: x.color }}
                  positions={positions}
                  eventHandlers={{
                    click: handlePoupupArrow,
                  }}
                >
                  <Popup className="mapPopup" />
                </Polyline>
              ) : null}
            </div>
          );
        })}

        <PolylineArrorw
          key={uuidv4()}
          polyline={null}
          mapPositionsData={mapPositionsData}
          isView={!viewAnimation && viewRoute}
          isArrowPolyyline={"routeSpeedColor"}
        />
      </div>
    );
  }
}

export default withMapControl(withMapPositions(withRouteSpeedColor(React.memo(IntelligenceMapSpeedColorRoute))));
